import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "GradingSettingDetail",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      setting: {},
      rules: [],
    };
  },

  computed: {
    isDefault() {
      return !!(this.setting && this.setting.is_default);
    },
  },

  methods: {
    getDetail() {
      this.isLoading = true;
      axios
        .get("gradingSetting/detail/" + this.$route.params.id)
        .then((res) => {
          if (res.data && res.data.success && res.data.data && res.data.data.id) {
            this.setting = res.data.data;
            this.getRules(this.setting.id);
          } else {
            this.setting = {};
            this.isLoading = false;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    getRules(settingId) {
      axios
        .get("gradingSetting/" + settingId + "/rule/list")
        .then((res) => {
          this.rules = (res.data && res.data.rules) ? res.data.rules : [];
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    confirmDeleteRule(ruleId) {
      if (window.confirm("Are you sure you want to delete this rule?")) {
        this.deleteRule(ruleId);
      }
    },

    deleteRule(ruleId) {
      this.isLoading = true;
      axios
        .delete("gradingSetting/" + this.$route.params.id + "/rule/delete/" + ruleId)
        .then((res) => {
          if (res.data.success == true) {
            this.$notification.success("Grading Rule Deleted Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.getRules(this.setting.id);
          } else {
            this.$notification.error(res.data.message || "Delete failed", {
              timer: 3,
              position: "bottomCenter",
            });
            this.isLoading = false;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Delete failed";
          this.$notification.error(msg, {
            timer: 3,
            position: "bottomCenter",
          });
          this.isLoading = false;
        });
    },

    showList() {
      this.$router.push({ name: "gradingSettingList" });
    },
  },

  mounted() {
    this.getDetail();
  },
};
